import { SecondaryButton, SecondaryLinkButton } from '@luminalearning/components';
import { useIntl } from 'react-intl';
import env from 'src/env';
import { useState } from 'react';
import BrandfolderSignupModal from './BrandfolderSignupModal';

type Props = {
    hasBrandfolderAccess: boolean
    brandfolderSignUp: Function;
    isBrandfolderSignUp: boolean;
    brandfolderError: boolean;
};
const ExploreLibaryCard = (props: Props) => {
    const {
        hasBrandfolderAccess, brandfolderSignUp, isBrandfolderSignUp, brandfolderError,
    } = props;
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const intl = useIntl();

    return (
        <div className={['invisible h-auto lg:visible relative overflow-hidden bg-primary flex flex-row mr-8 mt-8',
            'border-1-5 shadow-card border-card-normal rounded-md',
            'hover:border-card-hover active:shadow-none']
            .join('')}
        style={{
            width: '60rem',
        }}
        >
            <div className='border-1-5 z-30 bg-white pl-10 pt-10 ' style={{
                width: '40rem',
            }}>
                <div className='flex flex-col  w-search'>
                    <h1 className='text-headline-reg font-bold mb-6'>
                        {
                            intl.formatMessage({
                                id: 'LP_EXPORE_LIBRARY_TITILE',
                                defaultMessage: 'Explore the Resource Library',
                            })
                        }
                    </h1>
                    <p className='text-paragraph-reg'>
                        {
                            intl.formatMessage({
                                id: 'LP_EXPORE_LIBRARY_DESCRIPTION',
                                defaultMessage: 'We use a filesharing platform called Brandfolder to store and share our best and most up to date practitioner resources',
                            })
                        }
                    </p>
                    {hasBrandfolderAccess ? (
                        <SecondaryLinkButton
                            text={
                                intl.formatMessage({ id: 'LP_GO_TO_LIBARY', defaultMessage: 'Go to Resource Library' })
                            }
                            hasArrow={true}
                            direction='Right'
                            href={`${env.brandfolderUrl}`}
                            target='_blank'
                            className='mt-6 mb-6 w-60'/>
                    ) : (
                        <SecondaryButton
                            text={
                                intl.formatMessage({ id: 'LP_SIGN_UP_BRANDFOLDER', defaultMessage: 'Sign up to the Resource Library' })
                            }
                            hasArrow={true}
                            direction='Right'
                            onClick={() => {
                                setIsModalOpen(true);
                            }} className='mt-6 mb-6 w-60'/>
                    )}
                </div>
            </div>
            <img src='/img/brandfolderIcon.png' alt={intl.formatMessage({ id: 'LP_BRANDFOLDER', defaultMessage: 'BrandFolder' }) } />
            <BrandfolderSignupModal
                isOpen={isModalOpen}
                setOpen={setIsModalOpen}
                brandfolderError={brandfolderError}
                isBrandfolderSignUp={isBrandfolderSignUp}
                brandfolderSignUp={brandfolderSignUp} />
        </div>
    );
};

export default ExploreLibaryCard;